var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "Login" },
    [
      _vm.userId
        ? _c(
            "div",
            {
              staticClass: "isTest",
              class: { isTestCopy: _vm.userData.isSys != 0 ? false : true },
            },
            [
              _c("img", {
                attrs: { src: require("../assets/bgc.png"), alt: "" },
              }),
              _c(
                "div",
                {
                  staticClass: "btnBox",
                  on: {
                    click: function ($event) {
                      return _vm.startBtn(_vm.userId)
                    },
                  },
                },
                [_vm._v("开始模拟")]
              ),
            ]
          )
        : _c("div", { staticClass: "test" }, [
            _c("div", { staticClass: "loginTitle" }, [
              _vm._v(
                " " + _vm._s(_vm.isFindPwd ? "欢迎登录" : "找回密码") + " "
              ),
            ]),
            _c("div", { staticClass: "loginMain" }, [
              _vm.isFindPwd
                ? _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "ruleForm",
                          attrs: { model: _vm.formData, rules: _vm.rules },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "mobile" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "medium",
                                  readonly: "",
                                  onfocus: "this.removeAttribute('readonly');",
                                  placeholder: "请输入手机号码",
                                },
                                model: {
                                  value: _vm.formData.mobile,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "mobile",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.mobile",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "password" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "medium",
                                  readonly: "",
                                  onfocus: "this.removeAttribute('readonly');",
                                  placeholder: "请输入密码",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.formData.password,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.formData,
                                      "password",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "formData.password",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "validCode" } },
                            [
                              _c(
                                "div",
                                { staticClass: "validCodeBox" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      autocomplete: "off",
                                      size: "medium",
                                      onfocus:
                                        "this.removeAttribute('readonly');",
                                      type: "text",
                                      placeholder: "请输入验证码",
                                      maxlength: "20",
                                    },
                                    nativeOn: {
                                      keyup: function ($event) {
                                        if (
                                          !$event.type.indexOf("key") &&
                                          _vm._k(
                                            $event.keyCode,
                                            "enter",
                                            13,
                                            $event.key,
                                            "Enter"
                                          )
                                        ) {
                                          return null
                                        }
                                        return _vm.goEnter.apply(
                                          null,
                                          arguments
                                        )
                                      },
                                    },
                                    model: {
                                      value: _vm.formData.validCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.formData,
                                          "validCode",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "formData.validCode",
                                    },
                                  }),
                                  _c("img", {
                                    attrs: { src: _vm.ValidataUrl },
                                    on: { click: _vm.getValidata },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c("div", { staticClass: "forgetPwd" }, [
                        _c(
                          "span",
                          {
                            on: {
                              click: function () {
                                _vm.isFindPwd = false
                                _vm.findData = {
                                  mobile: "",
                                  password: "",
                                  repeatPwd: "",
                                  validCode: "",
                                }
                              },
                            },
                          },
                          [_vm._v("忘记密码")]
                        ),
                      ]),
                      _c(
                        "div",
                        { staticClass: "btnBox", on: { click: _vm.goEnter } },
                        [_vm._v("登录")]
                      ),
                      _c("div", { staticClass: "loginBottom" }, [
                        _c("span", [_vm._v("没有帐户？")]),
                        _c(
                          "span",
                          { staticClass: "go", on: { click: _vm.goRegiser } },
                          [_vm._v("去注册")]
                        ),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c(
                        "el-form",
                        {
                          ref: "findData",
                          attrs: { model: _vm.findData, rules: _vm.findRules },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "mobile" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "medium",
                                  readonly: "",
                                  onfocus: "this.removeAttribute('readonly');",
                                  placeholder: "请输入手机号码",
                                },
                                model: {
                                  value: _vm.findData.mobile,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.findData,
                                      "mobile",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "findData.mobile",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "validCode" } },
                            [
                              _c(
                                "div",
                                { staticClass: "validBox" },
                                [
                                  _c("el-input", {
                                    attrs: {
                                      size: "medium",
                                      readonly: "",
                                      onfocus:
                                        "this.removeAttribute('readonly');",
                                      placeholder: "请输入验证码",
                                    },
                                    model: {
                                      value: _vm.findData.validCode,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.findData,
                                          "validCode",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "findData.validCode",
                                    },
                                  }),
                                  _c(
                                    "div",
                                    { staticClass: "codeBox" },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          class: { codeGeting: _vm.isGeting },
                                          attrs: {
                                            type: "primary",
                                            disabled: _vm.disable,
                                          },
                                          on: { click: _vm.getVerifyCode },
                                        },
                                        [_vm._v(_vm._s(_vm.getCode))]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "password" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "medium",
                                  readonly: "",
                                  onfocus: "this.removeAttribute('readonly');",
                                  placeholder: "请输入新密码",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.findData.password,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.findData,
                                      "password",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "findData.password",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "", prop: "repeatPwd" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  size: "medium",
                                  readonly: "",
                                  onfocus: "this.removeAttribute('readonly');",
                                  placeholder: "请再次输入新密码",
                                  "show-password": "",
                                },
                                model: {
                                  value: _vm.findData.repeatPwd,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.findData,
                                      "repeatPwd",
                                      typeof $$v === "string" ? $$v.trim() : $$v
                                    )
                                  },
                                  expression: "findData.repeatPwd",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("div", { staticClass: "backBox" }, [
                            _c("span", { on: { click: _vm.backBtn } }, [
                              _vm._v("返回登录"),
                            ]),
                          ]),
                          _c(
                            "div",
                            {
                              staticClass: "btnBox",
                              on: { click: _vm.submit },
                            },
                            [_vm._v("提交")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
            ]),
          ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "查询考试成绩",
            width: "812px",
            visible: _vm.queryScoreVisable,
            center: "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.queryScoreVisable = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.scoreData, border: "", height: "400px" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "examPlanName",
                  label: "考试名称",
                  width: "360",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "beginTime", label: "考试时间", width: "280" },
              }),
              _c("el-table-column", {
                attrs: { prop: "score", width: "120", label: "成绩" },
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.queryScoreVisable = false
                    },
                  },
                },
                [_vm._v(" 取消 ")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.queryScoreVisable = false
                    },
                  },
                },
                [_vm._v(" 确定 ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("register-dialog", {
        ref: "registerDialog",
        attrs: { dialogVisible: _vm.dialogVisible },
        on: { changeDialogVisible: _vm.changeDialogVisible },
      }),
      _c("time-dialog", { ref: "timeDialog" }),
      _c("ks-roule-code-dialog", { ref: "ksRouleCodeDialog" }),
      _c("exam-plang-select", {
        ref: "examPlangSelect",
        on: { nextClick: _vm.planNext },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }